export default __webpack_public_path__ + "static/media/survey-end.114a3efb.svg";